import React from 'react';
import { Button } from "./button.jsx";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange,
  totalItems, // totalItems is not used in this UI, but keeping for compatibility
}) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    onItemsPerPageChange(Number(e.target.value));
  };

  const generatePaginationButtons = () => {
    const buttons = [];
    const page = currentPage;
    const last_page = totalPages;


    // Always show the first page
    buttons.push(
      <button
        key={1}
        onClick={() => onPageChange(1)}
        disabled={page === 1}
        className={`px-3 py-2 rounded text-sm font-medium transition-colors ${
          page === 1 ? "bg-[#44087D] text-white" : "bg-[#F4F0FD] text-[#8D82AA] hover:bg-[#44087D] hover:text-white"
        }`}
      >
        1
      </button>
    );

    // Show ellipsis if current page is far from the first page
    if (page > 3) {
      buttons.push(<span key="ellipsis-start" className="px-3 py-2 text-sm text-gray-600">...</span>);
    }

    // Show pages around the current page
    for (let i = Math.max(2, page - 1); i <= Math.min(last_page - 1, page + 1); i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`px-3 py-2 rounded text-sm font-medium transition-colors ${
            page === i ? "bg-[#44087D] text-white" : "bg-[#F4F0FD] text-[#8D82AA] hover:bg-[#44087D] hover:text-white"
          }`}
        >
          {i}
        </button>
      );
    }

    // Show ellipsis if current page is far from the last page
    if (page < last_page - 2) {
      buttons.push(<span key="ellipsis-end" className="px-3 py-2 text-sm text-gray-600">...</span>);
    }

    // Always show the last page
    if (last_page > 1) {
      buttons.push(
        <button
          key={last_page}
          onClick={() => onPageChange(last_page)}
          disabled={page === last_page}
          className={`px-3 py-2 rounded text-sm font-medium transition-colors ${
            page === last_page ? "bg-[#44087D] text-white" : "bg-[#F4F0FD] text-[#8D82AA] hover:bg-[#44087D] hover:text-white"
          }`}
        >
          {last_page}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-center my-6 gap-4">
      <div className="flex items-center gap-2">
        <Button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`px-3 py-2 rounded text-sm font-medium transition-colors ${
            currentPage === 1
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-[#44087D] text-white hover:bg-[#5a0a94]"
          }`}
        >
          Previous
        </Button>
        {generatePaginationButtons()}
        <Button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`px-3 py-2 rounded text-sm font-medium transition-colors ${
            currentPage === totalPages
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-[#44087D] text-white hover:bg-[#5a0a94]"
          }`}
        >
          Next
        </Button>
      </div>
      <div className="flex items-center gap-2">
        <label className="text-sm text-gray-600">Per page:</label>
        <select
          value={itemsPerPage}
          onChange={handleItemsPerPageChange}
          className="px-3 py-2 rounded text-sm bg-[#F4F0FD] text-[#8D82AA] border border-[#44087D] focus:outline-none"
        >
          {[10, 20, 30, 50, 100].map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Pagination;